(() => {
  const roots = document.querySelectorAll('[data-hv-oos-similar]');
  if (!roots.length) return;

  const addToCart = async (variantId, button) => {
    if (!variantId || !button) return;

    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    const labelEl = button.querySelector('[data-hv-btn-label]');
    const prevLabel = labelEl ? labelEl.textContent : null;
    if (labelEl) labelEl.textContent = 'Adding...';

    try {
      // Use liquid-ajax-cart if available
      if (window.liquidAjaxCart && window.liquidAjaxCart.cartRequestAdd) {
        await window.liquidAjaxCart.cartRequestAdd({
          items: [{ id: Number(variantId), quantity: 1 }]
        });

        // Open side cart
        const toggle = document.querySelector('[data-ajax-cart-toggle-class-button="js-my-cart-open"]');
        if (toggle) toggle.click();
        document.body.classList.add('js-my-cart-open');

      } else {
        // Fallback
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || 'Add to cart failed');
        }

        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      }

      if (labelEl) labelEl.textContent = 'Added';
      setTimeout(() => {
        if (labelEl) labelEl.textContent = prevLabel || 'Add to Cart';
      }, 900);
    } catch (e) {
      console.error('[HV OOS Similar] Add to cart error:', e);
      if (labelEl) labelEl.textContent = 'Try again';
      setTimeout(() => {
        if (labelEl) labelEl.textContent = prevLabel || 'Add to Cart';
      }, 1200);
    } finally {
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  };

  roots.forEach((root) => {
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-hv-similar-add]');
      if (!btn) return;

      e.preventDefault();
      if (btn.disabled) return;

      const variantId = btn.getAttribute('data-variant-id');
      addToCart(variantId, btn);
    });
  });
})();
